import Vue from 'vue'
import * as Sentry from "@sentry/vue";

import fgInput from './components/UIComponents/Inputs/formGroupInput'
import DropDown from './components/UIComponents/Dropdown'
import IEcharts from 'vue-echarts-v3/dist/VueECharts'
import TreeSelect from "@riophae/vue-treeselect";

function versionCompare(left, right) {
  if (typeof left !== 'string' || typeof right !== 'string') {
    return false;
  }

  let a = left.split('.').map(Number);
  let b = right.split('.').map(Number);
  let len = Math.max(a.length, b.length);

  for (let i = 0; i < len; i++) {
    let numA = i < a.length ? a[i] : 0;
    let numB = i < b.length ? b[i] : 0;

    if (numA > numB) {
      return 1;
    } else if (numA < numB) {
      return -1;
    }
  }
  return 0;
}

function globalNotify (type, text, time = 3000) {
  Vue.prototype.$notifications.notify({
    message: text,
    icon: 'mdi mdi-alert-circle',
    horizontalAlign: 'center',
    verticalAlign: 'top',
    type: type,
    timeout: time
  })
}

function getConvertDate (time, options = null) {
  if (time === 0 || time === null) return ''
  let date = new Date(time * 1000)
  if (!options) {
    options = {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }
  }else{
    if (options.timeZone === '' || options.timeZone === 'Local Time') {
      delete(options.timeZone)
    }
  }
  return date.toLocaleString(navigator.language, options)
}

function getConvertDate_short (time, options = null) {
  if (time === 0) return ''
  let date = new Date(time * 1000)
  if (!options) {
    options = {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    }
  }else{
    if (options.timeZone === '' || options.timeZone === 'Local Time') {
      delete(options.timeZone)
    }
  }
  return date.toLocaleString(navigator.language, options)
}

function getConvertDateAnyLines(time, options, count_lines = 1){
  const date = getConvertDate(time, options)
  let finish_date = ""
  if(count_lines === 1){
    finish_date = date
  } else {
    let up_date = date.split(', ')
    finish_date = `${up_date[0]}<br>${up_date[1]}`
  }
  return finish_date
}

function copyToClipboard(textToCopy) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    let textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }
}

function badAnswerHandler(bad_answer) {
  let level = ''
  try {
    let text = bad_answer.data.error.name
    if (typeof(bad_answer.data.error.message) === 'string'){
      text += '<br>' + bad_answer.data.error.message
    }else{
      if(Array.isArray(bad_answer.data.error.message)){
        for (let message of bad_answer.data.error.message) {
          text += '<br>' + message
        }
      }else{
        for (let key in bad_answer.data.error.message) {
          text += '<br>' + key + ': ' + bad_answer.data.error.message[key][0]
        }
      }
    }

    Vue.prototype.$notifications.notify({
      message: text,
      icon: 'mdi mdi-alert-circle',
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'danger',
      timeout: 5000
    })

    level = 'error'
  }catch{
    level = 'fatal'
  }
  console.error(bad_answer)
  Sentry.captureException(bad_answer, level);
}

function getDateYYYMMDD(ts){
  const d = new Date();
  const date = new Date(ts*1000 - d.getTimezoneOffset()*60*1000);
  return  date.toISOString().split('T')[0]
}

function restrictChars(evt) {
  let charCode = evt.which || evt.keyCode;
  if (!(
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 95 && charCode <= 106) ||
      charCode === 8 ||
      charCode === 46 ||
      (charCode === 86 && evt.ctrlKey)
  )) {
    evt.preventDefault();
  }
}

function trafficBalance(data) {
  if (!data) return null

  let traffic_GB = +data.rest / 1024
  if (traffic_GB > 5) {
    return { traffic: Math.round(traffic_GB), color: 'black' }
  } else if (traffic_GB > 1) {
    return { traffic: data.rest + ' MB', color: 'orange' }
  }
  return { traffic: data.rest + ' MB', color: 'red' }
}

function trafficStyle(data) {
  let percent = data.rest / data.limit * 100

  let traffic_GB = +data.rest / 1024
  if (traffic_GB > 5) {
    return '--p:' + percent + ';--c:green;'
  } else if (traffic_GB > 1) {
    return '--p:' + percent + ';--c:orange;'
  }
  return '--p:' + percent + ';--c:red;'
}

function globalStatusText(status) {
  if (!status)
    return "status_info.undefined"

  switch (status) {
    case -1:
      return "status_info.undefined"
    case 1:
      return "status_info.active"
    case 2:
      return "status_info.blocked"
    case 3:
      return "status_info.prepare"
    case 4:
      return "status_info.stop"
    default:
      return ""
  }
}

function globalStatusColor(status) {
  if (!status) return "gray";

  switch (status) {
    case -1:
      return "gray";
    case 1:
      return "green";
    case 2:
      return "yellow";
    case 3:
      return "blue";
    case 4:
      return "red";
  }
}

function dateTransform(date, sep){
  const dates = String(date).split("-");
  return `${dates[2]}${sep}${dates[1]}${sep}${dates[0]}`

}

const Global = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    // Vue.component('sis-select', SisSelect)
    Vue.component('IEcharts', IEcharts)
    Vue.component('tree-select', TreeSelect)

    Vue.prototype.getDateYYYMMDD = (ts) => getDateYYYMMDD(ts)
    Vue.prototype.restrict_chars = ($event) => restrictChars($event)
    Vue.prototype.get_date = (time, options) => getConvertDate(time, options)
    Vue.prototype.get_date_any_lines = (time, options, count_lines) => getConvertDateAnyLines(time, options, count_lines)
    Vue.prototype.get_date_short = (time, options) => getConvertDate_short(time, options)
    Vue.prototype.copy_to_clipboard = (param) => copyToClipboard(param)
    Vue.prototype.global_notify = (type, text, time) => globalNotify(type, text, time)
    Vue.prototype.bad_answer_handler = (answer) => badAnswerHandler(answer)
    Vue.prototype.version_compare = (left, right) => versionCompare(left, right)
    Vue.prototype.traffic_balance = (data) => trafficBalance(data)
    Vue.prototype.traffic_style = (data) => trafficStyle(data)
    Vue.prototype.global_status_text = (status) => globalStatusText(status)
    Vue.prototype.global_status_color = (status) => globalStatusColor(status)
    Vue.prototype.date_transform = (date, separation) => dateTransform(date, separation)
  }
}

export default Global
